const gtmForgotPasswordClicked = () => {
    dataLayer.push({
        event: 'forgot_password',
        step: 'submit_forgot_password',
        _clear: true,
    })
}

export default gtmForgotPasswordClicked
